import React from 'react';
import CommingSoon from '../../Shared/CommingSoon/CommingSoon';
import './PatientCare.css'

const PatientCare = () => {
    return (
        <div>
            <CommingSoon></CommingSoon>
        </div>
    );
};

export default PatientCare;